import React from 'react';

const Upload = ({clickHandler}) => (
    <a href="javascript:;"
    onClick={clickHandler}
    >
    <i className="fa fa-cloud-upload" aria-hidden="true"></i>上传文章
    </a>
);

export default Upload;